/**
 * Module-level caches and flags (e.g. "first load", factory caches) live as long as the page, but a test
 * file renders many "pages" with the same module instances. Modules register here how to go back to their
 * initial state; `resetCoreTestState()` (`coreTesting`) runs every reset after each test. Never used by the app.
 */
const resets = new Set<() => void>();

/**
 * Registers the reset of a module-level state, for tests.
 *
 * @param {Function} reset - Restores the initial value of the state
 * @returns {void}
 */
export const registerModuleStateReset = (reset: () => void): void => {
	resets.add(reset);
};

/**
 * Restores the initial state of every registered module (tests only).
 *
 * @returns {void}
 */
export const resetModuleState = (): void => {
	resets.forEach((reset) => reset());
};
